<template>
  <pbc-modal title='Create Variable' @close='$emit("close")' @done="done">
    <div>
      <p>{{source}}</p>
      <div class="flex m-2">
        <div class="flex-none w-48">Name</div>
        <input v-model='name' class="pbc-standard-input" placeholder='Enter name'/>
      </div>
      <div class="flex m-2">
        <div class="flex-none w-48">Initial Value</div>
        <input v-model='initial' class="pbc-standard-input" placeholder='Enter initial value'/>
      </div>
    </div>
  </pbc-modal>
</template>
<script>
import * as uuid from 'uuid';
export default {
  props:{
    source:{
      type:Array,
      required:true
    }
  },
  data() {
    return {
      name:'',
      initial:''
    }
  },
  methods:{
    done() {
      if (!this.name || !this.initial) {
        this.$emit("close");
        return;
      }
      console.log('PUSH', this.name, this.initial);
      console.log('source is', this.source);
      this.$emit("close");
      this.source.push({
        name:this.name,
        id:uuid.v4(),
        initial:this.initial
      });

    }
  }
}
</script>
